export const CustomerTypeByOption = {
  EXISTING_CUSTOMER: 'char2',
  NEW_CUSTOMER: 'char1',
};

export default CustomerTypeByOption;
